// eslint-disable-next-line
export const ALZA_SCORING_CHART_TOGGLE_DATA_TABLE = 'ALZA_SCORING_CHART_TOGGLE_DATA_TABLE'
